export const ROOTS = {
  AUTH: '/account',
  DASHBOARD: '',
  WORKSPACES: '/workspaces',
  ADMIN_USERS: '/admin/users',
  ADMIN_LIVE_MONITORING: '/admin/features/live-monitoring',
  ADMIN_LIVE_BIDDING: '/admin/features/live-bidding',
  ADMIN_SSO: '/admin/sso',
  ADMIN_ONBOARD: '/admin/onboard',
};

// ----------------------------------------------------------------------

export const paths = {
  profile: {
    root: ROOTS.AUTH,
  },
  // DASHBOARD
  dash: {
    root: ROOTS.DASHBOARD,

    // Brand > Search Performance
    searchPerformanceOverview: ROOTS.DASHBOARD + '/brand/search-performance/overview',
    searchPerformanceFunnel: ROOTS.DASHBOARD + '/brand/search-performance/traffic',
    searchPerformanceExplore: ROOTS.DASHBOARD + '/brand/search-performance/explore',
    searchPerformanceConversionsAnalysis: ROOTS.DASHBOARD + '/brand/search-performance/conversions',
    searchPerformanceClusterManager: ROOTS.DASHBOARD + '/brand/search-performance/cluster-manager',

    // Brand > Visibility
    visibilityOverview: ROOTS.DASHBOARD + '/brand/visibility/overview',
    visibilityCompetitors: ROOTS.DASHBOARD + '/brand/visibility/competitors',
    visibilitySearchTerms: ROOTS.DASHBOARD + '/brand/visibility/search-terms',
    visibilityAds: ROOTS.DASHBOARD + '/brand/visibility/ads',
    visibilityLocal: ROOTS.DASHBOARD + '/brand/visibility/local',

    // Brand > Campaign Leaks
    campaignLeaks: ROOTS.DASHBOARD + '/brand/campaign-leaks',
    campaignLeaksLeakedSearchTerms: ROOTS.DASHBOARD + '/brand/campaign-leaks/leaked-search-terms',
    campaignLeaksAccountPerformance: ROOTS.DASHBOARD + '/brand/campaign-leaks/account-performance',

    // Brand > Brand Shield
    brandShieldKeywordsExact: '/brand/brand-shield/keywords/exact',
    brandShieldKeywordsOther: '/brand/brand-shield/keywords/other',
    brandShieldCampaigns: ROOTS.DASHBOARD + '/brand/brand-shield/campaigns',
    brandShieldInfringement: '/brand/brand-shield/brand-infringement',
    brandShieldBidStratTesting: ROOTS.DASHBOARD + '/brand/brand-shield/bid-strat-testing',
    activeMode: ROOTS.DASHBOARD + '/brand/brand-shield/active-mode',
    scraping: ROOTS.DASHBOARD + '/brand/brand-shield/scraping',
    koBiddingMaxCPC: ROOTS.DASHBOARD + '/brand/brand-shield/ko-bidding/max-cpc',
    koBiddingTROAS: ROOTS.DASHBOARD + '/brand/brand-shield/ko-bidding/troas',
    koBiddingTCPA: ROOTS.DASHBOARD + '/brand/brand-shield/ko-bidding/tcpa',
    koBiddingTargetImpressionShare: ROOTS.DASHBOARD + '/brand/brand-shield/ko-bidding/target-impression-share',
    koBiddingAuto: ROOTS.DASHBOARD + '/brand/brand-shield/ko-bidding-auto',
    koBiddingCampaignBased: '/admin/features/live-bidding/campaign-based',
    koBiddingAdGroupBased: '/admin/features/live-bidding/ad-group-based',

    // Non Brand
    nonBrandSearchPerformance: ROOTS.DASHBOARD + '/non-brand/search-performance',
    nonBrandSearchPerformanceClusterManager: ROOTS.DASHBOARD + '/non-brand/search-performance/cluster-manager',
    nonBrandVisibility: ROOTS.DASHBOARD + '/non-brand/visibility',

    // Competitors
    leaderboardMarketLeaders: ROOTS.DASHBOARD + '/competitors/leaderboard/market-leaders',
    leaderboardTrackedCompetitors: ROOTS.DASHBOARD + '/competitors/leaderboard/tracked-competitors',
    leaderboardCompetitorsSelection: ROOTS.DASHBOARD + '/competitors/leaderboard/competitors-selection',
    conquestMode: ROOTS.DASHBOARD + '/competitors/conquest-mode',

    // Legacy / misc
    competitorsMonitoring: ROOTS.DASHBOARD + '/competitors-monitoring',
    competitorFocus: ROOTS.DASHBOARD + '/competitor-focus',
    textAds: ROOTS.DASHBOARD + '/text-ads',
    productListingAds: ROOTS.DASHBOARD + '/product-listing-ads',
    brandWayback: ROOTS.DASHBOARD + '/brand-wayback',
    visibility: ROOTS.DASHBOARD + '/visibility',
    businessOverview: ROOTS.DASHBOARD + '/business-overview',
    brandOverview: ROOTS.DASHBOARD + '/brand-overview',
    optimization: ROOTS.DASHBOARD + '/optimization',

    //
    creative: ROOTS.DASHBOARD + '/creative',
    landing: ROOTS.DASHBOARD + '/landing',
    video: ROOTS.DASHBOARD + '/videos',
    copy: ROOTS.DASHBOARD + '/copy',
    performance: ROOTS.DASHBOARD + '/performance/facebook',
    attribution: ROOTS.DASHBOARD + '/attribution',
    applications: {
      connections: {
        create: (type: string) => `/apps/${type}/connect`,
        app: (type: string) => `/apps/${type}`,
        root: `/apps`,
      },
    },
  },
  admin: {
    cockpit: '/admin/cockpit',
    user: ROOTS.ADMIN_USERS,
    userAdd: `${ROOTS.ADMIN_USERS}/add`,
    liveMonitoring: ROOTS.ADMIN_LIVE_MONITORING,
    liveMonitoringAdd: `${ROOTS.ADMIN_LIVE_MONITORING}/add`,

    liveBiddingKeywordBased: `${ROOTS.ADMIN_LIVE_BIDDING}/search`,
    liveBiddingKeywordBasedActiveMode: `${ROOTS.ADMIN_LIVE_BIDDING}/search/active-mode`,

    liveBiddingKeywordBasedKoBidding: `${ROOTS.ADMIN_LIVE_BIDDING}/search/ko-bidding`,
    liveBiddingKeywordBasedKoBiddingMaxCPC: `${ROOTS.ADMIN_LIVE_BIDDING}/search/ko-bidding/max-cpc`,
    liveBiddingKeywordBasedKoBiddingTROAS: `${ROOTS.ADMIN_LIVE_BIDDING}/search/ko-bidding/troas`,
    liveBiddingKeywordBasedKoBiddingTCPA: `${ROOTS.ADMIN_LIVE_BIDDING}/search/ko-bidding/tcpa`,
    liveBiddingKeywordBasedKoBiddingTargetImpressionShare: `${ROOTS.ADMIN_LIVE_BIDDING}/search/ko-bidding/target-impression-share`,
    liveBiddingKeywordBasedKoBiddingAuto: `${ROOTS.ADMIN_LIVE_BIDDING}/search/ko-bidding/auto`,

    liveBiddingCampaignBased: `${ROOTS.ADMIN_LIVE_BIDDING}/campaign-based`,
    liveBiddingAdGroupBased: `${ROOTS.ADMIN_LIVE_BIDDING}/ad-group-based`,

    workspaces: ROOTS.WORKSPACES,
    workspacesAdd: `${ROOTS.WORKSPACES}/add`,
    workspacesSetup: `${ROOTS.WORKSPACES}/setup`,
    workspacesSetupEdit: `${ROOTS.WORKSPACES}/:id/setup`,

    sso: {
      root: ROOTS.ADMIN_SSO,
      add: `${ROOTS.ADMIN_SSO}/add`,
      list: `${ROOTS.ADMIN_SSO}/list`,
      edit: (id: number) => `${ROOTS.ADMIN_SSO}/${id}/edit`,
      delete: (id: number) => `${ROOTS.ADMIN_SSO}/${id}/delete`,
    },

    onboard: {
      root: ROOTS.ADMIN_ONBOARD,
      banners: {
        list: `${ROOTS.ADMIN_ONBOARD}/cai4phiegh1ooW3ahnoh9eiruTae6ca5/banners`,
        add: `${ROOTS.ADMIN_ONBOARD}/cai4phiegh1ooW3ahnoh9eiruTae6ca5/banners/add`,
      },
    },

  },
  workspaces: {
    root: ROOTS.WORKSPACES,
    workspace: (id: number) => `${ROOTS.WORKSPACES}/${id}`,
  }
};
